import {get,postJson,post} from '@/api/request/CommonRequest'
import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'

export let cbglMethod = {}

cbglMethod.selectType  = function (params) {
  return post('/cbgl/selectType',params)
}

cbglMethod.selectList  = function (params) {
  return post('/cbgl/selectList',params)
}



